import COriginalClass from './COriginalClass'
export default COriginalClass;